
























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Ajax from "@/lib/ajax";

@Component
export default class ResetPassword extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  @Prop({type: Number, required: true}) userId: number;
  newPassword: string = '';
  confirmPassword: string = '';
  loading: boolean = false;

  async save() {

    if (this.newPassword != this.confirmPassword) {
      this.$Message.error(this.L('密码不一致'));
      return;
    }
    if (!this.newPassword) {
      this.$Message.error(this.L('密码不能为空'));
      return;
    }

    this.loading = true;
    try {
      let response = await Ajax.post("/api/services/app/user/ResetPassword", {
        userId: this.userId,
        newPassword: this.newPassword
      });
      this.loading = false;

      this.newPassword = '';
      this.confirmPassword = '';
      this.$Notice.success(this.L('修改成功'));
      this.$emit('save-success');
      this.$emit('input', false);
    } catch (e) {
      this.loading = false;
    }


  }

  cancel() {

    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    }
  }

}
